export const customUrlBase = `/custom-objects/:objectId/:id`;

const paths = new Map([
  ['record', `${customUrlBase}/details`],
  ['automations', `${customUrlBase}/automations`],
]);

export default paths;
